import React, { useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { toast } from "sonner";
import { api } from "../lib/api";
import { KeyRound } from "lucide-react";

const ResetPassword = () => {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const nav = useNavigate();
  const [pwd, setPwd] = useState("");
  const [pwd2, setPwd2] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pwd !== pwd2) { toast.error("As senhas não coincidem"); return; }
    if (pwd.length < 6) { toast.error("Mínimo 6 caracteres"); return; }
    setBusy(true);
    try {
      await api.post("/auth/reset", { token, new_password: pwd });
      toast.success("Senha redefinida. Faça login com a nova senha.");
      nav("/entrar", { replace: true });
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Não foi possível redefinir a senha");
    } finally { setBusy(false); }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-16">
      <div className="text-xs uppercase tracking-[0.18em] text-slate-500 flex items-center gap-1.5">
        <KeyRound className="w-3.5 h-3.5" /> Redefinir senha
      </div>
      <h1 className="font-display font-bold text-3xl text-[#0B2B62] tracking-tight mt-1">Escolha uma nova senha</h1>
      {!token ? (
        <p className="mt-4 text-red-600 text-sm">Link inválido. <Link to="/esqueci-minha-senha" className="underline">Solicitar novo</Link></p>
      ) : (
        <form onSubmit={submit} className="mt-6 space-y-4">
          <div>
            <label className="text-sm font-medium text-slate-700">Nova senha</label>
            <input data-testid="reset-pwd" required type="password" minLength={6} value={pwd} onChange={(e) => setPwd(e.target.value)}
              className="mt-1.5 w-full px-3 py-2.5 border border-slate-300 rounded-md outline-none focus:ring-2 focus:ring-[#0B2B62]" />
          </div>
          <div>
            <label className="text-sm font-medium text-slate-700">Confirmar senha</label>
            <input data-testid="reset-pwd2" required type="password" minLength={6} value={pwd2} onChange={(e) => setPwd2(e.target.value)}
              className="mt-1.5 w-full px-3 py-2.5 border border-slate-300 rounded-md outline-none focus:ring-2 focus:ring-[#0B2B62]" />
          </div>
          <button data-testid="reset-submit" disabled={busy} type="submit"
            className="w-full py-3 bg-[#0B2B62] text-white rounded-md font-semibold hover:bg-slate-800 disabled:opacity-60">
            {busy ? "Salvando..." : "Redefinir senha"}
          </button>
        </form>
      )}
    </div>
  );
};

export default ResetPassword;
